import { makeStyles } from '@material-ui/core';

import { XMEI_PRIMARY_COLOR } from 'src/consts/common';

export const useStyles = makeStyles((theme) => ({
  grid: {
    minHeight: '100vh',
    backgroundColor: XMEI_PRIMARY_COLOR,
  },
  root: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '70%',
    },
    backgroundColor: '#FFF',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 30,
    paddingBottom: 30,
    [theme.breakpoints.down('sm')]: {
      boxShadow: 'none',
    },
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: 250,
    marginBottom: 20,
  },
  logo: {
    width: '60%',
    [theme.breakpoints.up('md')]: {
      width: '80%',
    },
    height: 'auto',
  },
}));
